var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChipGroup',{attrs:{"aria-label":"Dates","scroll":""},model:{value:(_vm.selectedPeriod),callback:function ($$v) {_vm.selectedPeriod=$$v},expression:"selectedPeriod"}},_vm._l((_vm.availableDates),function({ name, value }){return _c('Chip',{key:value,attrs:{"value":value,"disabled":_vm.disabled,"selectable":""}},[_vm._v(_vm._s(name))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }